import AppEvents from 'Shared/app-events';

import CatalogPriceModel from 'Models/catalogPriceModel';
import StockInfoModel from 'Models/stockInfoModel';
import OrderUnitModel from 'Models/orderUnitModel';

import CartApi from 'Api/cart-api';

export default class SalesInfoModel
{
    constructor(data){
        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        OrderUnit: {
            create: options => new OrderUnitModel(options.data, this)
        },
        CatalogPrice: {
            create: options => new CatalogPriceModel(options.data)
        },
        StockInfo: {
            create: options => new StockInfoModel(options.data)
        }
    }

    //Properties
    loading = ko.observable();

    template = ko.pureComputed(() => 'salesinfo-tpl');

    
    hint(min, max, int) {
        var hint = [];

        const orderUnit = this.selectedOrderUnit();
        if (!orderUnit) return "";

        if (orderUnit.MinQuantity() > 1) {
            hint.push(`${min} ${orderUnit.MinQuantity()}`);
        }
        if (orderUnit.MaxQuantity() > 0) {
            hint.push(`(${max} ${orderUnit.MaxQuantity()}`);
        }
        if (orderUnit.Interval() > 0) {
            hint.push(`(${int} ${orderUnit.Interval()}`);
        }

        let formattedString = hint.join(",");

        if (formattedString.length) {
            formattedString = "(" + formattedString + ")";
        }

        if (orderUnit.PriceUnitQuantityFormatted()) {
            formattedString = orderUnit.OrderUnitText() + " " + formattedString;
        }

        return formattedString;
    };

    hintClass = ko.pureComputed(() => this.hasHint() ? "unit-hint" : "");
        
    //unitTpl = ko.pureComputed(() => this.OrderUnits().length === 1 ? 'unit-display-tpl' : 'unit-select-tpl');

    isExtendedUnit = ko.pureComputed(() => this.OrderUnit?.IsExtendedUnit());

    addbuttonTpl = ko.pureComputed(() => this.isExtendedUnit() ? 'cart-extended-unit-tpl' : 'cart-tpl');

    cart = (form, e) => {
        var submitBtn = form.querySelector("button[type='submit']");

        const model = ko.dataFor(form);

        if (model.OrderUnit.IsExtendedUnit()) {
            AppEvents.emit(`${CartApi.Events.EXTENDED_UNIT}.${model.OrderUnit.ExtendedUnitClientModel()}`, model);
        }
        else
        {
            AppEvents.emit(CartApi.Events.ADD, Object.assign({ element: submitBtn }, model));
        }
    }
}
